import { DatePipe, DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from '@env/environment';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	ImageServerInfoModel,
	ServerInfoModel,
} from '@models/server-info-model';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorReportService } from '@services/error-report.service';
import { ServerInfoService } from '@services/server-info.service';
import { StatusService } from '@services/v2/status.service';
import { AppState } from '@shared/app-state';
import { UserTypeConstant } from '@shared/user-type-constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { UserService } from '@services/user.service';
import { BaseModal } from '../base-modal';

@Component({
	selector: 'browser-info-modal',
	styleUrls: ['./browser-info.component.scss'],
	template: `
		<div class="modal-body">
		  <button class="close" (click)="closeAndDestroy()">
		    <i class="fa-light fa-xmark"></i>
		  </button>
		  <div class="browser-info-item">
		    <div>
		      <h3>{{ 'BROWSER-INFO.HEADER' | translate }}</h3>
		      <div>
		        <p>
		          <b>{{ 'BROWSER-INFO.ALIAS' | translate }}</b
		            >: <span>{{ accountAlias }}</span>
		          </p>
		          <p>
		            <b>{{ 'BROWSER-INFO.NAME' | translate }}</b
		              >: <span>{{ accountName }}</span>
		            </p>
		            <p>
		              <b>{{ 'BROWSER-INFO.NUMBER' | translate }}</b
		                >: <span>{{ accountNumber }}</span>
		              </p>
		              <p>
		                <b>{{ 'BROWSER-INFO.CUSTOMERCODE' | translate }}</b
		                  >: <span>{{ customerCode }}</span>
		                </p>
		                <p>
		                  <b>{{ 'BROWSER-INFO.CONTACTCODE' | translate }}</b
		                    >: <span>{{ contactCode }}</span>
		                  </p>
		                  <p>
		                    <b>{{ 'BROWSER-INFO.BROWSER' | translate }}</b
		                      >:
		                      <span
		                        >{{ browser }}
		                        {{ 'BROWSER-INFO.VERSION' | translate }}
		                        {{ browserVersion }}</span
		                        >
		                      </p>
		                      @if (device) {
		                        <p>
		                          <b>{{ 'BROWSER-INFO.DEVICE' | translate }}</b
		                            >: <span>{{ device }}</span>
		                          </p>
		                        }
		                        <p>
		                          <b>{{ 'BROWSER-INFO.OS' | translate }}</b
		                            >:
		                            <span
		                              >{{ os }}
		                              {{
		                              osVersion
		                              ? ('BROWSER-INFO.VERSION' | translate)
		                              : ''
		                              }}
		                              {{ osVersion }}</span
		                              >
		                            </p>
		                            <p>
		                              <b>{{ 'BROWSER-INFO.USERAGENT' | translate }}</b
		                                >:<br />
		                                <span>{{ userAgent }}</span>
		                              </p>
		                              <p>
		                                <b
		                                  >{{ 'BROWSER-INFO.QUOTA.USAGE' | translate }}
		                                  @if (showLinkToStoragePage) {
		                                    <a
		                                      [routerLink]="['storage']"
		                                      (click)="closeAndDestroy()"
		                                      ><i
		                                      class="fa-solid fa-circle-info info-circle"
		                                    ></i></a>
		                                    }</b
		                                    ><br />
		                                    @if (totalSpace) {
		                                      <span>
		                                        {{ 'BROWSER-INFO.QUOTA.TOTAL' | translate }} :
		                                        {{ totalSpace.toFixed(0) | number }} Mb<br />
		                                        {{ 'BROWSER-INFO.QUOTA.USED' | translate }} :
		                                        {{ usedSpace.toFixed(2) | number }} Mb<br />
		                                        {{
		                                        'BROWSER-INFO.QUOTA.PERCENTAGE' | translate
		                                        }}
		                                        : {{ percentUsed.toFixed(2) | number }}%<br />
		                                      </span>
		                                    }
		                                    @if (!totalSpace) {
		                                      <span>
		                                        {{
		                                        'BROWSER-INFO.QUOTA.NOT.SUPPORTED'
		                                        | translate
		                                        }}
		                                      </span>
		                                    }
		                                  </p>
		                                  @if (version) {
		                                    <p>
		                                      <b>{{ 'BROWSER-INFO.VERSION' | translate }}</b
		                                        >: <span>{{ version }}</span>
		                                      </p>
		                                    }
		                                    <p>
		                                      <b>{{ 'BROWSER-INFO.DATAVERSION' | translate }}</b
		                                        >: <span>{{ dataVersion }}</span>
		                                      </p>
		                                      <p>
		                                        <b>{{ 'BROWSER-INFO.DATASERVER' | translate }}</b
		                                          >: <span>{{ dataServer }}</span>
		                                        </p>
		                                        @if (serverInfo) {
		                                          <p class="ml-5">
		                                            <b>{{
		                                              'BROWSER-INFO.SERVER.REGION' | translate
		                                              }}</b
		                                              >: <span>{{ serverInfo.Region }}</span>
		                                            </p>
		                                            <p class="ml-5">
		                                              <b>{{
		                                                'BROWSER-INFO.SERVER.MACHINENAME'
		                                                | translate
		                                                }}</b
		                                                >: <span>{{ serverInfo.MachineName }}</span>
		                                              </p>
		                                              <p class="ml-5">
		                                                <b>{{
		                                                  'BROWSER-INFO.SERVER.BUILD' | translate
		                                                  }}</b
		                                                  >:
		                                                  <span
		                                                    >{{
		                                                    serverInfo.Build | date : 'mediumDate'
		                                                    }}
		                                                    {{
		                                                    serverInfo.Build | date : 'HH:mm:ss'
		                                                    }}</span
		                                                    >
		                                                  </p>
		                                                }
		
		                                                <p>
		                                                  <b>{{ 'BROWSER-INFO.IMAGEURL' | translate }}</b
		                                                    >: <span>{{ imageUrl }}</span>
		                                                  </p>
		                                                  @if (imageServerInfo) {
		                                                    <p class="ml-5">
		                                                      <b>{{
		                                                        'BROWSER-INFO.SERVER.REGION' | translate
		                                                        }}</b
		                                                        >: <span>{{ imageServerInfo.region }}</span>
		                                                      </p>
		                                                      <p class="ml-5">
		                                                        <b>{{
		                                                          'BROWSER-INFO.SERVER.BUILD' | translate
		                                                          }}</b
		                                                          >:
		                                                          <span
		                                                            >{{
		                                                            imageServerInfo.build
		                                                            | date : 'mediumDate'
		                                                            }}
		                                                            {{
		                                                            imageServerInfo.build
		                                                            | date : 'HH:mm:ss'
		                                                            }}</span
		                                                            >
		                                                          </p>
		                                                        }
		
		                                                        @if (imageUrl !== imageUrlCDN) {
		                                                          <p>
		                                                            <b>{{ 'BROWSER-INFO.IMAGEURLCDN' | translate }}</b
		                                                              >: <span>{{ imageUrlCDN }}</span>
		                                                            </p>
		                                                          }
		                                                          @if (
		                                                            imageUrl !== imageUrlCDN && imageCdnServerInfo
		                                                            ) {
		                                                            <p class="ml-5">
		                                                              <b>{{
		                                                                'BROWSER-INFO.SERVER.REGION' | translate
		                                                                }}</b
		                                                                >: <span>{{ imageCdnServerInfo.region }}</span>
		                                                              </p>
		                                                              <p class="ml-5">
		                                                                <b>{{
		                                                                  'BROWSER-INFO.SERVER.BUILD' | translate
		                                                                  }}</b
		                                                                  >:
		                                                                  <span
		                                                                    >{{
		                                                                    imageCdnServerInfo.build
		                                                                    | date : 'mediumDate'
		                                                                    }}
		                                                                    {{
		                                                                    imageCdnServerInfo.build
		                                                                    | date : 'HH:mm:ss'
		                                                                    }}</span
		                                                                    >
		                                                                  </p>
		                                                                }
		                                                              </div>
		                                                            </div>
		                                                          </div>
		                                                          <div class="create-error-report">
		                                                            <div>
		                                                              <button class="btn btn-primary" (click)="openWebSupport()">
		                                                                {{ 'COMMON.CREATEERRORREPORT' | translate }}
		                                                              </button>
		                                                            </div>
		                                                          </div>
		                                                        </div>
		`,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DatePipe, DecimalPipe, TranslatePipe, RouterLink],
})
export class BrowserInfoComponent extends BaseModal implements OnInit {
	public accountAlias?: string;
	public accountName?: string;
	public accountNumber?: string;
	public customerCode?: string;
	public contactCode?: string;
	public browser: string;
	public browserVersion: string;
	public os: string;
	public osVersion: string;
	public device: string | null;
	public userAgent: string;
	public totalSpace: number;
	public usedSpace: number;
	public percentUsed: number;
	public version?: string;
	public appBuild: string;
	public dataVersion: string;
	public serverInfo: ServerInfoModel | null;
	public imageServerInfo: ImageServerInfoModel | null;
	public imageCdnServerInfo: ImageServerInfoModel | null;
	public dataServer: string | null;
	public imageUrlCDN: string | null;
	public imageUrlCDNRegion: string;
	public imageUrl: string | null;
	public imageUrlRegion: string;
	public showLinkToStoragePage: boolean = false;

	constructor(
		breadcrumbService: BreadcrumbService,
		private userService: UserService,
		private deviceDetector: DeviceDetectorService,
		private errorReportService: ErrorReportService,
		private appState: AppState,
		private serverInfoService: ServerInfoService,
		private versionService: StatusService
	) {
		super(breadcrumbService);
	}

	async ngOnInit() {
		const user = await this.userService.GetUser();

		this.accountName = user?.CustomerName;
		this.accountNumber = user?.CustomerNo;
		this.customerCode = user?.CustomerCode;
		this.contactCode = user?.ContactCode;
		this.accountAlias = user?.Alias;
		this.showLinkToStoragePage =
			user?.Type === UserTypeConstant.Employee ||
			this.appState.showLinkToStoragePage;

		const device = this.deviceDetector.getDeviceInfo();

		this.browser = device.browser;
		this.browserVersion = device.browser_version;
		this.device = device.device != 'Unknown' ? device.device : null;
		this.os = device.os;
		this.osVersion = device.os_version;
		this.userAgent = device.userAgent;

		if ('storage' in navigator && 'estimate' in navigator.storage) {
			const estimate = await navigator.storage.estimate();

			this.totalSpace = estimate?.quota ?? 0 / 1000000;
			this.usedSpace = estimate?.usage ?? 0 / 1000000;
			this.percentUsed = (this.usedSpace / this.totalSpace) * 100;
		}

		this.version = this.versionService.getApiVersion();

		this.serverInfo = await this.serverInfoService.getServerInfo();
		this.dataServer = environment.dataUrl;

		this.imageUrl = environment.imageUrl;
		this.imageUrlCDN = environment.imageCDNUrl;

		this.imageServerInfo =
			await this.serverInfoService.getImageServerInfo();
		if (this.imageUrl === this.imageUrlCDN) {
			this.imageCdnServerInfo = this.imageServerInfo;
		} else {
			this.imageCdnServerInfo =
				await this.serverInfoService.getImageCdnServerInfo();
		}
	}

	openWebSupport() {
		this.errorReportService.openWebSupport(null, null, null);
	}
}
